<section id="header-section" class="text-center">
  <div class="container grid content-center h-screen relative">
    <h1 class="text-3xl font-extrabold text-gray-900 mb-4">
      Développeur Full Stack
    </h1>
    <img
      class="w-64 h-64 rounded-full mx-auto border-2 border-blue-700 px-1 py-1 mb-4 object-cover "
      src="./images/moi.jpg"
      alt=""
      width="1505"
      height="2088"
    />
    <blockquote
      class="p-4 italic border-l-4 bg-neutral-100 text-neutral-600 border-neutral-500 quote mx-auto mb-5"
    >
      <p class="mb-2">"Trouvé une jolie Catch phrase a mettre juste ici !"</p>
      <cite>
        -
        <a href="..." target="_blank" rel="noopener noreferrer">
          Hugo Suissia
        </a>
      </cite>
    </blockquote>
    <div class="mx-auto">
      <a
        href="https://www.linkedin.com/in/hugo-suissia-47653414b/"
        class="inline-block mx-10"
        target="_blank"
      >
        <img
          class="w-8 h-8"
          src="./images/linkedin.png"
          alt="linkedin icon"
          width="16"
          height="16"
        />
      </a>
      <a
        href="https://github.com/hsuissia"
        class="inline-block mx-10"
        target="_blank"
      >
        <img
          class="w-9 h-9"
          src="./images/github.png"
          alt="github icon"
          width="16"
          height="16"
        />
      </a>
    </div>
    <div class="absolute bottom-2 left-1/2">
      <a href="#who-section" class="">
        <img
          class="w-8 h-8 animate-bounce"
          src="./images/scroll-down.png"
          alt="Icone qui indique de scroll"
          width="16"
          height="16"
        />
      </a>
    </div>
  </div>
</section>
